/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CancelMultipartUploadParams } from "../models/cancelMultipartUploadParams";

import type { CompleteMultipartUploadParams } from "../models/completeMultipartUploadParams";

import type { CreateMultipartUploadRequest } from "../models/createMultipartUploadRequest";

import type { DownloadAssetParams } from "../models/downloadAssetParams";

import type { DownloadFileParams } from "../models/downloadFileParams";

import type { GetSignedUrlForFileBody } from "../models/getSignedUrlForFileBody";

import type { GetSignedUrlForFileParams } from "../models/getSignedUrlForFileParams";

import type { GetUploadBucket200 } from "../models/getUploadBucket200";

import type { GetUploadBucketParams } from "../models/getUploadBucketParams";

import type { UploadFileBody } from "../models/uploadFileBody";

import type { UploadPartBody } from "../models/uploadPartBody";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Download Asset
 */
export const downloadAsset = (
  assetId: string,
  params?: DownloadAssetParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/asset/download/${encodeURIComponent(String(assetId))}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getDownloadAssetQueryKey = (
  assetId?: string,
  params?: DownloadAssetParams,
) => {
  return [
    `/api/file/asset/download/${assetId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDownloadAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  assetId: string,
  params?: DownloadAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadAssetQueryKey(assetId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAsset>>> = ({
    signal,
    meta,
  }) => downloadAsset(assetId, params, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assetId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAsset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAsset>>
>;
export type DownloadAssetQueryError = ErrorType<unknown>;

export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  assetId: string,
  params: undefined | DownloadAssetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadAsset>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  assetId: string,
  params?: DownloadAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadAsset>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  assetId: string,
  params?: DownloadAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download Asset
 */

export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  assetId: string,
  params?: DownloadAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadAssetQueryOptions(assetId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download Asset
 */
export const prefetchDownloadAsset = async <
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  assetId: string,
  params?: DownloadAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadAssetQueryOptions(assetId, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Cancel Multipart
 */
export const cancelMultipartUpload = (
  params?: CancelMultipartUploadParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/cancel-multipart-upload`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getCancelMultipartUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMultipartUpload>>,
    TError,
    { params?: CancelMultipartUploadParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMultipartUpload>>,
  TError,
  { params?: CancelMultipartUploadParams },
  TContext
> => {
  const mutationKey = ["cancelMultipartUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMultipartUpload>>,
    { params?: CancelMultipartUploadParams }
  > = (props, context) => {
    const { params } = props ?? {};

    return cancelMultipartUpload(params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMultipartUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMultipartUpload>>
>;

export type CancelMultipartUploadMutationError = ErrorType<unknown>;

/**
 * @summary Cancel Multipart
 */
export const useCancelMultipartUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelMultipartUpload>>,
      TError,
      { params?: CancelMultipartUploadParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelMultipartUpload>>,
  TError,
  { params?: CancelMultipartUploadParams },
  TContext
> => {
  const mutationOptions = getCancelMultipartUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Cloud Storage Provider
 */
export const getCloudStorageProvider = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    { url: `/api/file/cloud-storage-provider`, method: "GET", signal },
    options,
  );
};

export const getGetCloudStorageProviderQueryKey = () => {
  return [`/api/file/cloud-storage-provider`] as const;
};

export const getGetCloudStorageProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCloudStorageProvider>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCloudStorageProviderQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCloudStorageProvider>>
  > = ({ signal, meta }) =>
    getCloudStorageProvider({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCloudStorageProvider>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCloudStorageProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCloudStorageProvider>>
>;
export type GetCloudStorageProviderQueryError = ErrorType<unknown>;

export function useGetCloudStorageProvider<
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCloudStorageProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCloudStorageProvider>>,
          TError,
          Awaited<ReturnType<typeof getCloudStorageProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCloudStorageProvider<
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCloudStorageProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCloudStorageProvider>>,
          TError,
          Awaited<ReturnType<typeof getCloudStorageProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCloudStorageProvider<
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCloudStorageProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Cloud Storage Provider
 */

export function useGetCloudStorageProvider<
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCloudStorageProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCloudStorageProviderQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Cloud Storage Provider
 */
export const prefetchGetCloudStorageProvider = async <
  TData = Awaited<ReturnType<typeof getCloudStorageProvider>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCloudStorageProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetCloudStorageProviderQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Complete Multipart
 */
export const completeMultipartUpload = (
  params?: CompleteMultipartUploadParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/complete-multipart-upload`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getCompleteMultipartUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeMultipartUpload>>,
    TError,
    { params?: CompleteMultipartUploadParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeMultipartUpload>>,
  TError,
  { params?: CompleteMultipartUploadParams },
  TContext
> => {
  const mutationKey = ["completeMultipartUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeMultipartUpload>>,
    { params?: CompleteMultipartUploadParams }
  > = (props, context) => {
    const { params } = props ?? {};

    return completeMultipartUpload(params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteMultipartUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeMultipartUpload>>
>;

export type CompleteMultipartUploadMutationError = ErrorType<unknown>;

/**
 * @summary Complete Multipart
 */
export const useCompleteMultipartUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeMultipartUpload>>,
      TError,
      { params?: CompleteMultipartUploadParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeMultipartUpload>>,
  TError,
  { params?: CompleteMultipartUploadParams },
  TContext
> => {
  const mutationOptions = getCompleteMultipartUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Multipart Upload
 */
export const createMultipartUpload = (
  createMultipartUploadRequest: CreateMultipartUploadRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/create-multipart-upload`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMultipartUploadRequest,
      signal,
    },
    options,
  );
};

export const getCreateMultipartUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultipartUpload>>,
    TError,
    { data: CreateMultipartUploadRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMultipartUpload>>,
  TError,
  { data: CreateMultipartUploadRequest },
  TContext
> => {
  const mutationKey = ["createMultipartUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMultipartUpload>>,
    { data: CreateMultipartUploadRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return createMultipartUpload(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMultipartUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMultipartUpload>>
>;
export type CreateMultipartUploadMutationBody = CreateMultipartUploadRequest;
export type CreateMultipartUploadMutationError = ErrorType<unknown>;

/**
 * @summary Multipart Upload
 */
export const useCreateMultipartUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMultipartUpload>>,
      TError,
      { data: CreateMultipartUploadRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMultipartUpload>>,
  TError,
  { data: CreateMultipartUploadRequest },
  TContext
> => {
  const mutationOptions = getCreateMultipartUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Download File
 */
export const downloadFile = (
  fileId: string,
  params?: DownloadFileParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/download/${encodeURIComponent(String(fileId))}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getDownloadFileQueryKey = (
  fileId?: string,
  params?: DownloadFileParams,
) => {
  return [`/api/file/download/${fileId}`, ...(params ? [params] : [])] as const;
};

export const getDownloadFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  params?: DownloadFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadFileQueryKey(fileId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({
    signal,
    meta,
  }) => downloadFile(fileId, params, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!fileId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFile>>
>;
export type DownloadFileQueryError = ErrorType<unknown>;

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  params: undefined | DownloadFileParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  params?: DownloadFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  params?: DownloadFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download File
 */

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  params?: DownloadFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadFileQueryOptions(fileId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download File
 */
export const prefetchDownloadFile = async <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  fileId: string,
  params?: DownloadFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadFileQueryOptions(fileId, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Signed Url For File
 */
export const getSignedUrlForFile = (
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/file/signed-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getSignedUrlForFileBody,
      params,
      signal,
    },
    options,
  );
};

export const getGetSignedUrlForFileQueryKey = (
  getSignedUrlForFileBody?: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
) => {
  return [
    `/api/file/signed-url`,
    ...(params ? [params] : []),
    getSignedUrlForFileBody,
  ] as const;
};

export const getGetSignedUrlForFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSignedUrlForFileQueryKey(getSignedUrlForFileBody, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSignedUrlForFile>>
  > = ({ signal, meta }) =>
    getSignedUrlForFile(
      getSignedUrlForFileBody,
      params,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSignedUrlForFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSignedUrlForFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSignedUrlForFile>>
>;
export type GetSignedUrlForFileQueryError = ErrorType<unknown>;

export function useGetSignedUrlForFile<
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params: undefined | GetSignedUrlForFileParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignedUrlForFile>>,
          TError,
          Awaited<ReturnType<typeof getSignedUrlForFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSignedUrlForFile<
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignedUrlForFile>>,
          TError,
          Awaited<ReturnType<typeof getSignedUrlForFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSignedUrlForFile<
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Signed Url For File
 */

export function useGetSignedUrlForFile<
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSignedUrlForFileQueryOptions(
    getSignedUrlForFileBody,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Signed Url For File
 */
export const prefetchGetSignedUrlForFile = async <
  TData = Awaited<ReturnType<typeof getSignedUrlForFile>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  getSignedUrlForFileBody: GetSignedUrlForFileBody,
  params?: GetSignedUrlForFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSignedUrlForFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetSignedUrlForFileQueryOptions(
    getSignedUrlForFileBody,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Upload Bucket
 */
export const getUploadBucket = (
  params?: GetUploadBucketParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<GetUploadBucket200>(
    { url: `/api/file/upload-bucket`, method: "GET", params, signal },
    options,
  );
};

export const getGetUploadBucketQueryKey = (params?: GetUploadBucketParams) => {
  return [`/api/file/upload-bucket`, ...(params ? [params] : [])] as const;
};

export const getGetUploadBucketQueryOptions = <
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUploadBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUploadBucketQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadBucket>>> = ({
    signal,
    meta,
  }) => getUploadBucket(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUploadBucket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUploadBucketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUploadBucket>>
>;
export type GetUploadBucketQueryError = ErrorType<unknown>;

export function useGetUploadBucket<
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetUploadBucketParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadBucket>>,
          TError,
          Awaited<ReturnType<typeof getUploadBucket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUploadBucket<
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUploadBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadBucket>>,
          TError,
          Awaited<ReturnType<typeof getUploadBucket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUploadBucket<
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUploadBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Upload Bucket
 */

export function useGetUploadBucket<
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUploadBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUploadBucketQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Upload Bucket
 */
export const prefetchGetUploadBucket = async <
  TData = Awaited<ReturnType<typeof getUploadBucket>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetUploadBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUploadBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetUploadBucketQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Upload File
 */
export const uploadFile = (
  uploadFileBody: UploadFileBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (uploadFileBody.file !== undefined) {
    formData.append(`file`, uploadFileBody.file);
  }

  return executeFetch<unknown>(
    {
      url: `/api/file/upload-file`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getUploadFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: UploadFileBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: UploadFileBody },
  TContext
> => {
  const mutationKey = ["uploadFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { data: UploadFileBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return uploadFile(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;
export type UploadFileMutationBody = UploadFileBody;
export type UploadFileMutationError = ErrorType<unknown>;

/**
 * @summary Upload File
 */
export const useUploadFile = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { data: UploadFileBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: UploadFileBody },
  TContext
> => {
  const mutationOptions = getUploadFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload Part
 */
export const uploadPart = (
  uploadPartBody: UploadPartBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (uploadPartBody.file !== undefined) {
    formData.append(`file`, uploadPartBody.file);
  }
  if (uploadPartBody.partNumber !== undefined) {
    formData.append(`partNumber`, uploadPartBody.partNumber.toString());
  }
  if (uploadPartBody.uploadId !== undefined) {
    formData.append(`uploadId`, uploadPartBody.uploadId);
  }

  return executeFetch<unknown>(
    {
      url: `/api/file/upload-part`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getUploadPartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPart>>,
    TError,
    { data: UploadPartBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPart>>,
  TError,
  { data: UploadPartBody },
  TContext
> => {
  const mutationKey = ["uploadPart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPart>>,
    { data: UploadPartBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return uploadPart(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPartMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPart>>
>;
export type UploadPartMutationBody = UploadPartBody;
export type UploadPartMutationError = ErrorType<unknown>;

/**
 * @summary Upload Part
 */
export const useUploadPart = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadPart>>,
      TError,
      { data: UploadPartBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadPart>>,
  TError,
  { data: UploadPartBody },
  TContext
> => {
  const mutationOptions = getUploadPartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
